import React from "react";
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import classnames from 'classnames';

import {Svg} from "../../../components/svg";
import {ChecklistItem, BUTTON_TYPES} from "./checklist-item";

import copy from './copy.json';


export const SSNVerificationChecklistItem = inject('completeMyPaperworkStore', 'historyStore')(
    observer(
        class _SSNVerificationChecklistItem extends React.Component {
            static propTypes = {
                historyStore: PropTypes.shape({
                    history: PropTypes.shape({
                        push: PropTypes.func.isRequired
                    }),
                }).isRequired,
                completeMyPaperworkStore: PropTypes.shape({
                    hasSubmittedSSNVerification: PropTypes.bool.isRequired,
                    isSSNVerificationRequired: PropTypes.bool.isRequired,
                    isSSNVerificationAccepted: PropTypes.bool.isRequired,
                    isSSNVerificationComplete: PropTypes.bool.isRequired,
                    getPaperworkUrl: PropTypes.func.isRequired,
                }).isRequired,
                isBrpFinancialTheme: PropTypes.bool,
            };

            copy = copy.ssn_verification;

            getSubText() {
                const {completeMyPaperworkStore} = this.props;

                if (!completeMyPaperworkStore.hasSubmittedSSNVerification) {
                    return null;
                }
                if (!completeMyPaperworkStore.isSSNVerificationComplete) {
                    return this.copy.processing_text;
                }
                if (!completeMyPaperworkStore.isSSNVerificationAccepted) {
                    return this.copy.rejected_text;
                }
                return null;
            }

            getButtonType() {
                const {completeMyPaperworkStore} = this.props;
                if (completeMyPaperworkStore.isSSNVerificationAccepted) {
                    return BUTTON_TYPES.DONE;
                }
                if (completeMyPaperworkStore.isSSNVerificationComplete) {
                    return BUTTON_TYPES.RESUBMIT;
                }
                return BUTTON_TYPES.SUBMIT_DOCS;
            }

            goToSSNVerification = () => {
                let cmpStore = this.props.completeMyPaperworkStore;
                let applicantUuid = cmpStore[`${cmpStore.prefix}Uuid`];
                this.props.historyStore.history.push(
                    cmpStore.getPaperworkUrl('/ssn-verification', applicantUuid)
                );
            };

            render() {
                const {
                    isSSNVerificationRequired,
                    isSSNVerificationAccepted,
                } = this.props.completeMyPaperworkStore;
                const checklistItemProps = {
                    title: this.copy.title,
                    buttonType: this.getButtonType(),
                    isBrpFinancialTheme: this.props.isBrpFinancialTheme,
                };

                if (!isSSNVerificationRequired) {
                    return null;
                }

                if (!isSSNVerificationAccepted) {
                    checklistItemProps.onClickButton = this.goToSSNVerification;
                }

                const subText = this.getSubText();
                return (
                    <ChecklistItem {...checklistItemProps}>
                        {subText && (
                            <div className="border-top border-secondary mt-3 pt-2">
                                <Svg className={classnames("mr-2", this.props.isBrpFinancialTheme ? "spark-text-primary" : "spark-text-note")} svg="processing-icon"/>
                                <span className="spark-text-14px-bold">
                                    {subText}
                                </span>
                            </div>
                        )}
                    </ChecklistItem>
                );
            }
        }
    )
);
